module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Boniswil-aa1a35249b7b547ce891d4bbe709bb6e.svg";